import { render } from "./PlantList.vue?vue&type=template&id=250f62f6&ts=true"
import script from "./PlantList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlantList.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/Users/voquanghoa/code/medicinal-plant/MedicinalPlant.Frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/plant/PlantList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "250f62f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('250f62f6', __exports__)) {
    api.reload('250f62f6', __exports__)
  }
  
  module.hot.accept("./PlantList.vue?vue&type=template&id=250f62f6&ts=true", () => {
    api.rerender('250f62f6', render)
  })

}


export default __exports__